module.exports = __webpack_public_path__ + "img/Logo-HorasdaVida.d37a0dd1.jpg";